import NewsItemPage from "../pages/news/Item/page";
import NewsPage from "../pages/news/List/page";
import SmiNewsPage from "../pages/news/Smi/page";
import { SocialFeedPage } from "../pages/news/SocialFeed/page";

export const SmiPageApp = () => {
    return (
       <SmiNewsPage />
    );
}

export const SocialFeedApp = () => {
    return <SocialFeedPage />;
}

export const NewsListApp = () => {
    return <NewsPage />;
}

export const NewsItemApp = () => {
    return <NewsItemPage />;
}